import React, { useContext,useState } from 'react'
import { Button , TextField , Grid , Typography ,Container ,Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import CopyToClipboard from 'react-copy-to-clipboard';
import {Assignment , Phone ,PhoneDisabled} from '@material-ui/icons';

import { SocketContext } from '../SocketContext';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  gridContainer: {
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  container: {
    
    width: '600px',
    margin: '35px 0',
    padding: 0,
    borderRadius:'10%',
    [theme.breakpoints.down('xs')]: {
      width: '80%',
    },
  },
  margin: {
    marginTop: 20,
    color:"#3289C0"
  },
  padding: {
    padding: 20,
  },
  paper: {
    borderRadius:"4%",
    padding: '10px 20px',
    // border: '2px solid black',
  },
 }));


const Options = ({children}) => {
  const {me,callAccepted ,name, setname , leaveCall ,callUser,callEnded} = useContext(SocketContext);
  const [idToCall, setidToCall] = useState('');
  const classes = useStyles();
  return (
    <Container  className={classes.container}>
    <Paper elevation={10} className={classes.paper}>
      <form className={classes.root} noValidate autoComplete='off'>
        <Grid container  className={classes.gridContainer}>
          <Grid  xs={12} md={6} className={classes.padding}>
              <Typography gutterBottom variant='h6'>
                Make Your Room ID
              </Typography>
              <TextField label="enter your name" value={name} onChange={(e)=>setname(e.target.value)} fullWidth/>
              <CopyToClipboard text={me} className={classes.margin}>
                <Button variant="contained" color="#3289C0" fullWidth  startIcon={<Assignment fontSize='large'/>}>
                      Copy Your Room Id 
                </Button>
              </CopyToClipboard>
          </Grid>
          {/* <hr size="2" width="1" color="black">   */}
          <Grid item xs={12} md={6} className={classes.padding}>
              <Typography gutterBottom variant='h6'>
                Make Call
              </Typography>
              <TextField label="Room ID " value={idToCall} onChange={(e)=>setidToCall(e.target.value)} fullWidth/>
              {callAccepted && !callEnded ?(
                    <Button variant='contained' color="secondary"
                     startIcon={<PhoneDisabled fontSize="large"/>}
                     fullWidth
                     onClick={leaveCall}
                     className={classes.margin}
                     >
                      Hang Up
                    </Button>
              ):(
                  <Button
                    Elevated
                    variant="outlined"
                    color="#47A"
                    startIcon={<Phone fontSize="large" />}
                    fullWidth
                    onClick={() => callUser(idToCall)}
                    className={classes.margin}
                  >
                    Call
                  </Button>
              )}
          </Grid>
        </Grid>
      </form>
      {children}
    </Paper>
  
    
    </Container>
  )
}

export default Options